import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import ZGrid from '../components/ZGrid';
import { withStyles } from '@material-ui/core/styles';
import Card from '@mui/material/Card';
import Paper from '@mui/material/Paper';
import CardContent from '@mui/material/CardContent';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ZTextBox from '../components/ZTextBox';
import classNames from 'classnames';
import ZButton from '../components/ZButton';
import QrReader from 'react-web-qr-reader';
import QrCdeIcon from '../asset/images/qrCode.png';
import { Typography } from '@mui/material';
import InputBase from '@mui/material/InputBase';
import { toIndianRupee, alphaNumericOnly } from '../utils/common_function/common_function';
import color from '../utils/constants/Colors';
import label from '../utils/constants/label';
import Alert from '../components/alert/alert';
import scanner from '../asset/images/camera.png'


const delay = 500;

const previewStyle = {
    // height: 180,
    // width: 300,
    height: 250,
    width: 161,
    // display: "flex",
    // justifyContent: "center",
};


function Transaction(props) {
    const classes = props.classes
    const [result, setResult] = useState('');
    const [token, setToken] = useState('');
    const [tokenerror, setTokenerror] = useState('');

    const [miriAccountNo, setMiriAccountNo] = useState('');

    const [isScanQrCode, setIsScanQrCode] = useState(false);
    //const [isScanQrCode, setIsScanQrCode] = React.useState(null);

    const [alert, setAlert] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState('');
    const [severity, setSeverity] = React.useState('success');


    const [accountNo, setAccountNo] = useState('NA');
    const [amount, setAmount] = useState('NA');
    const [mobile, setMobile] = useState('NA');
    const [name, setName] = useState('NA');
    const [remark, setRemark] = useState('');

    const [scannerFlag, setScannerFlag] = useState(true);
    const [scannerOnOffFlag, setScannerOnOffFlag] = useState(false);


    useEffect(() => {
        let value = props.allData
        if (props.allData != undefined && props.miriAccNo != undefined && value != undefined && value != "") {
            setAccountNo(value.toAcc);
            setAmount(value.amount);
            setMiriAccountNo(props.miriAccNo);
            setMobile(props.allData.mobile);
            setRemark(props.allData.remark);
            setName(props.allData.beneficiaryName)
        }
    }, [props.value]);

    const handleScan = (result) => {

        setTokenerror("")
        if (result.data) {
            let tokenAndMiriAccount = result.data.split(',');
            if (tokenAndMiriAccount.length == 2) {
                setScannerFlag(false);
                setScannerOnOffFlag(false);
                let miriAccNo = tokenAndMiriAccount[1].replace(/ /g, "");
                let token = tokenAndMiriAccount[0].replace(/ /g, "");
                setIsScanQrCode(false);
                if (token.length == 9) {
                    setMiriAccountNo(miriAccNo);
                    setToken(tokenAndMiriAccount[0]);
                    setTokenerror('');
                    props.submit(token, tokenAndMiriAccount[1], "S");
                } else {
                    setToken("");
                    setTokenerror('');
                    setAlertMessage(label.messages.kindlyProvide + " " + label.messages.valid + " " + label.fundTransfer.token);
                    setSeverity('warning');
                    setAlert(true);
                    // setTokenerror(label.messages.kindlyProvide + " " + label.messages.valid + " " + label.fundTransfer.token);
                }
            } else {
                setToken("");
                setTokenerror('');
                setAlertMessage(label.messages.kindlyProvide + " " + label.messages.valid + " " + label.fundTransfer.token);
                setSeverity('warning');
                setAlert(true);
                // setTokenerror(label.messages.kindlyProvide + " " + label.messages.valid + " " + label.fundTransfer.token)
            }
        }
    };



    const handleError = (error) => {
        console.log(error);
    };

    const scanQrCode = () => {
        setScannerOnOffFlag(true)
    }

    const handleClose = () => {
        setIsScanQrCode(null);
        setScannerOnOffFlag(false);
    };

    const onChange = (e) => {
        if (alphaNumericOnly(e.target.value.replaceAll(/\s/g, ""))) {
            if (e.target.value.replaceAll(/\s/g, "").length < 10) {
                let trimValue = e.target.value.replace(/ /g, "").toUpperCase();
                let setSpace = trimValue.match(/.{1,3}/g);
                if (setSpace == null) {
                    setToken('')
                    setTokenerror('')
                } else {
                    setToken(setSpace.join(" "))
                    setTokenerror('')
                }
            }
        }
    }

    const createMask = (string) => {
        var token = string
        return token.replace(/(\w{3})/, " ");
    }

    const submit = () => {
        setScannerOnOffFlag(false);
        var trimedToken = token.replaceAll(/\s/g, "")
        var tokenValid = false;
        if (trimedToken == '') {
            setTokenerror(label.messages.kindlyProvide + " " + label.fundTransfer.token)
        }
        else if (trimedToken.length == 9) {
            tokenValid = true;
        } else {
            tokenValid = false;
            setTokenerror(label.messages.kindlyProvide + " " + label.messages.valid + " " + label.fundTransfer.token)
        }
        //Vaidation for Token
        tokenValid &&
            props.submit(trimedToken, miriAccountNo, "S");
    }

    const handleAlert = () => {
        setAlert(false);
    };

    return (
        <div>
            <ZGrid container>
                <Card className={classes.profileCard}>
                    <CardContent>
                        {/* <div className={classes.cardHeader}>2FA Token</div> */}

                        <ZGrid container spacing={2} className={classes.GridContainer} style={{ paddingTop: 20 }}>
                            <ZGrid item xs={6} md={6}>
                                <div style={{ display: 'flex', flexDirection: "column", borderRightWidth: 1, alignItems: "center", borderBottomWidth: 1, }}>
                                    <ZTextBox style={{ width: "70%", margin: "auto" }}
                                        value={token}
                                        onChange={(e) => onChange(e)}
                                        autoFocus={true} label="Please Enter OTP" variant="standard" className={classes.miriID}
                                        InputProps={{
                                            classes: {
                                                input: classes.resize,
                                            },
                                        }}
                                    >
                                    </ZTextBox>
                                    {tokenerror == "" ? (
                                        <span className={classes.errorStyle}>{""}</span>
                                    ) : (
                                        <span className={classes.errorStyle}>{tokenerror}</span>
                                    )}

                                    <ZGrid container style={{ justifyContent: "center", marginTop: 20 }}>
                                        <ZButton variant="outlined" onClick={() => scanQrCode()}
                                            color="primary" name="Open Scanner" endIcon={<img
                                                src={scanner}
                                                style={{ height: 20, }}
                                            ></img>} className={classes.btnLogin}>
                                        </ZButton>
                                    </ZGrid>

                                    <Paper elevation={4} style={{ padding: "0px 2.15rem", marginTop: 20, position: "relative", top: "-4rem" }}>
                                        {scannerOnOffFlag &&
                                            <div>
                                                <div className={classes.clearIcon} onClick={() => handleClose()}>
                                                    &#x2715;
                                                </div>

                                                <div className={classes.camStyle}>

                                                    <QrReader
                                                        delay={delay}
                                                        style={previewStyle}
                                                        onError={handleError}
                                                        onScan={handleScan}
                                                        open={isScanQrCode}
                                                        handleClose={handleClose}
                                                    />

                                                </div>
                                            </div>
                                        }
                                    </Paper>

                                </div>
                            </ZGrid>
                            <ZGrid item xs={6} md={6} style={{ display: "flex", flexDirection: "column", paddingRight: 12, borderLeftColor: '#eee', borderLeftStyle: 'solid', borderLeftWidth: '0.1em', }}>
                                <div className={classes.transactDetails} style={{ paddingLeft: 20, marginTop: 0 }}>
                                    <Typography style={{ paddingBottom: 10, marginBottom: 8, fontWeight: "bold", color: "#f7941d", textTransform: "uppercase" }}>Transaction Details</Typography>

                                    <ZGrid container>
                                        <ZGrid item xs={6} className={classes.header}>Name</ZGrid>
                                        <ZGrid item xs={6} style={{ marginBottom: 8, }}>{name}</ZGrid>
                                    </ZGrid>

                                    <ZGrid container>
                                        <ZGrid item xs={6} className={classes.header}>Account Number</ZGrid>
                                        <ZGrid item xs={6} style={{ marginBottom: 8, }}>{accountNo}</ZGrid>
                                    </ZGrid>
                                    <ZGrid container>
                                        <ZGrid item xs={6} className={classes.header}>Amount (USD)</ZGrid>
                                        <ZGrid item xs={6} style={{ marginBottom: 8, }}><span style={{fontWeight:'bold'}}>(&#36;) </span>{amount}</ZGrid>
                                    </ZGrid>

                                    <ZGrid container>
                                        <ZGrid item xs={6} className={classes.header}>Mobile</ZGrid>
                                        <ZGrid item xs={6} style={{ marginBottom: 8, }}>{mobile}</ZGrid>
                                    </ZGrid>

                                    <Typography id="alert-dialog-title" className={classes.dialogMessage}>
                                        <b style={{ color: "#3b2e58" }}>Remarks</b>
                                        <div className={classes.unsubscribeMessage}>
                                            <Typography>{remark}</Typography>
                                        </div>
                                    </Typography>
                                </div>
                                <ZGrid container spacing={3}>
                                    <ZGrid item xs={12} md={12} className={classes.actionButton} style={{ padding: "0px 12px", marginTop: 20 }}>
                                        <div className={classes.dflex}>
                                            <ZButton variant="outlined"
                                                color="primary" name="Back" onClick={() => props.back()} className={classes.btnLogin}></ZButton>
                                            <ZButton variant="contained"
                                                color="primary" name="Next" onClick={() => submit()} className={classes.btnLogin} loading={props.submitLoader} ></ZButton>
                                        </div>
                                    </ZGrid>
                                </ZGrid>
                            </ZGrid>
                        </ZGrid>


                    </CardContent>
                </Card>
                <Alert
                    open={alert}
                    message={alertMessage}
                    onClose={handleAlert}
                    severity={severity}
                ></Alert>
            </ZGrid>
        </div>
    );
}

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },

    unsubscribeMessage: {
        color: "#171717",
        margin: "8px 0px"
    },

    camStyle: {
        //   display: "flex",
        //   flexDirection: "column",
        //   justifyContent: "center",
        position: "relative",
    },

    header: {
        paddingBottom: 5,
        fontWeight: 600,
        // color: "rgb(146, 39, 143)",
        fontFamily: 'Noto Sans '
    },

    transactDetails: {
        "& .MuiTypography-root": {
            fontFamily: 'Noto Sans'
        }
    },

    clearIcon: {
        float: "right",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        zIndex: 2,
        right: 5,
        margin: "8px 4px",
        borderRadius: 4,
        fontSize: 10,
        color: "#fff",
        width: 20,
        height: 20,
        alignItems: "center",
        background: "#212529",
        '& + div > section > section': {
            position: "unset !important",
            paddingTop: "0 !important"

        },

        '& + div > section > section div': {
            //backgroundColor:"red"
            position: "absolute !important",
            display: "block !important",
            boxShadow: "none !important",
            background: "none !important",
            border: "none !important",
            top: "2.5rem !important",
            //width:"70% !important",
            height: "70% !important",
            background: "linear-gradient(to right, #F64E60 4px, transparent 4px) 0 0, linear-gradient(to right, #F64E60 4px, transparent 4px) 0 100%, linear-gradient(to left, #F64E60 4px, transparent 4px) 100% 0, linear-gradient(to left, #F64E60 4px, transparent 4px) 100% 100%, linear-gradient(to bottom,#F64E60 4px, transparent 4px) 0 0, linear-gradient(to bottom, #F64E60 4px, transparent 4px) 100% 0, linear-gradient(to top, #F64E60 4px, transparent 4px) 0 100%, linear-gradient(to top, #F64E60 4px, transparent 4px) 100% 100%",
            backgroundRepeat: "no-repeat",
            backgroundSize: "20px 20px",
        }
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },


    GridContainer: {
        minHeight: 90
    },
    profileCard: {
        width: "100%",
        boxShadow: "0 20px 27px 0 rgb(0 0 0 / 5%) !important",
        borderRadius: "0.75rem !important"
    },
    cardHeader: {
        fontWeight: 600,
        textTransform: "uppercase",
        color: "#344767",
        marginBottom: 20
    },
    actionButton: {
        display: "flex", justifyContent: "flex-end",


    },
    cardSubHeader: {
        textTransform: "uppercase",
        color: "#344767",
        fontSize: 14,
        padding: "40px 0px 10px 0px",
        fontWeight: 600
    },
    dflex: {
        display: "flex",
        '& .MuiButton-root': {
            marginTop: "12px !important"
        }
    },
    dialogMessage: {
        fontSize: "1rem",
        // background: "rgba(87, 113, 219, 0.09)",
        padding: 20,
        color: 'rgb(13, 60, 97)',
        // background: 'rgb(232, 244, 253)',
        padding: '6px 10px',
        border: "1px solid #efd9fd",
        background: "#efd9fd",
        marginTop: "10px !important"
    },
    cardContent: { minHeight: 60 },
    resize: {
        fontSize: 25
    },
    errorStyle: {
        fontSize: 12,
        color: color.ERROR,
        height: 14,
        marginTop: 5,
        width: "70%", margin: "auto"
    }
})

export default withStyles(styles)(Transaction);